import { isOnChangeMulti, isOnChangeSingle } from './helpers';
export function handleChange(value, onChange, valueKey, isMulti) {
    if (!onChange)
        return;
    if (!value) {
        onChange(null, null);
        return;
    }
    if (Array.isArray(value) && isOnChangeMulti(onChange, isMulti)) {
        onChange(value.map(function (option) { return option[valueKey]; }), value);
    }
    if (!Array.isArray(value) && isOnChangeSingle(onChange, isMulti)) {
        onChange(value[valueKey], value);
    }
}
//# sourceMappingURL=handleChange.js.map